import { apiCall, ApiConfig } from '../../config/api'
import { getUserDataAction } from '../actions/userDataActions'
import { call, put, takeEvery, select, delay } from '@redux-saga/core/effects'
import { AxiosResponse } from 'axios'
import { GET_USER_DATA } from '../types/userDataActionsTypes'
import { UserWms } from '../../interfaces/Picking/Picking'
import { RootState } from '../store'

// Se modifica metodo para incorporar reintentos al obtener el email ya que se realizaban llamados con email en NULL
export function* getUserDataAsync() {
  try {
    let userEmail: string = ''
    let attempts = 0
    const maxAttempts = 10

    // Reintenta hasta que el email esté disponible
    while (!userEmail && attempts < maxAttempts) {
      userEmail = yield select(
        (state: RootState) =>
          state.userProfile?.userProfileState?.userProfile?.email?.toLowerCase() ||
          ''
      )

      if (!userEmail) {
        console.log(`Intento ${attempts + 1}: Email vacío, esperando...`)
        yield delay(500) // Espera 500ms
        attempts++
      }
    }

    if (!userEmail) {
      throw new Error('Email no disponible después de múltiples intentos')
    }

    const { status, data }: AxiosResponse<UserWms> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.UserApi}/ByEmail?email=${encodeURIComponent(userEmail)}`
    )

    if (status === 200) {
      yield put(getUserDataAction(data))
    }
  } catch (error) {
    console.error('Error en getUserDataAsync:', error)
    yield put(getUserDataAction(undefined, ''))
  }
}

export function* watchGetUserDataAsync() {
  yield takeEvery(GET_USER_DATA, getUserDataAsync)
}
